export const COLUMN_PROCESSOR_STARTED = 1
export const COLUMN_PROCESSOR_PROGRESS = 2
export const COLUMN_PROCESSOR_FINISHED = 3
export const SUBMISSION_STARTED = 4
export const SUBMISSION_PHASE_CHANGED = 5
export const VALIDATION_STARTED = 6
export const VALIDATION_PROGRESS = 7
export const VALIDATION_FINISHED = 8
export const DATASET_INDEXING_STARTED = 9
export const DATASET_INDEXING_FINISHED = 10
